import { render, staticRenderFns } from "./_nav_category_level_one.vue?vue&type=template&id=4be179eb"
import script from "./_nav_category_level_one.vue?vue&type=script&lang=js"
export * from "./_nav_category_level_one.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports